module.exports = __webpack_public_path__ + "img/lens-160-minus-10.b7c54572.png";